<header>
  <div class="header_full">
    <div class="header_container">
      <img src="assets/brigitteLogo.png" alt="logo du cabinet" id="logo">
      <div class="header_text">
          <!-- <p class="title1">Dr. Brigitte <b>Denis</b></p>
          <p class="title2">GASTRO-ENTEROLOGIE</p> -->
          <h1 class="title1">Dr. Brigitte <b>Denis</b></h1>
          <h2 class="title2">GASTRO-ENTEROLOGIE</h2>
      </div>
    </div>
    <div class="nav">
      <app-nav-bar></app-nav-bar>
    </div>
  </div>
  <!-- <div class="breakLine"></div> -->
</header>
<div [@routeAnimations]="prepareRoute(outlet)" >
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<!-- <router-outlet></router-outlet> -->
<!-- <footer></footer> -->